import fetchJsonp from 'fetch-jsonp';

export const autocatalogService = {
  brands,
  models
};

function models(brand) {
  const requestOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  };

  return fetch(`https://autocatalog.smartdriving.io/api/CarModels/ByCarBrandId/${brand}`, requestOptions).then(handleResponse);
}

function brands() {
  const requestOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  };

  return fetch(`https://autocatalog.smartdriving.io/api/CarBrands`, requestOptions).then(handleResponse);
}

function handleResponse(response) {
  return response.text().then(text => {
    const data = text && JSON.parse(text);
    if (!response.ok) {
      const error = data || response.statusText;
      return Promise.reject(error);
    }

    return data;
  });
}



// WEBPACK FOOTER //
// ./src/services/autocatalog.service.js